import { pb } from '../helpers/pocketbase_helper';

export const ProcessDetectionService = {
  /**
   * Verifica si un centro de costo es de proceso de impresión
   * @param {Object} centroCosto - Centro de costo con información del proceso
   * @returns {boolean} True si es proceso de impresión
   */
  isImpresionProcess(centroCosto) {
    if (!centroCosto || !centroCosto.proceso) {
      return false;
    }

    // Verificar si el proceso es "impresión" (comparación directa)
    return centroCosto.proceso.toLowerCase().trim() === 'impresión' || 
           centroCosto.proceso.toLowerCase().trim() === 'impresion';
  },

  /**
   * Obtiene la lista de procesos de impresión desde la base de datos
   * @returns {Promise<Array<string>>} Lista de nombres de procesos de impresión
   */
  async getImpresionProcesses() {
    try {
      const result = await pb.collection('mapa_nombre_proceso_tabla').getList(1, 100, {
        filter: 'tabla = "impresión"',
        fields: 'nombre_proceso'
      });
      
      return result.items.map(item => item.nombre_proceso);
    } catch (error) {
      console.error('Error fetching impresion processes:', error);
      throw new Error('Error al obtener procesos de impresión');
    }
  },

  /**
   * Obtiene información detallada de un proceso específico
   * @param {string} procesoNombre - Nombre del proceso
   * @returns {Promise<Object|null>} Información del proceso o null si no existe
   */
  async getProcessInfo(procesoNombre) {
    try {
      const result = await pb.collection('mapa_nombre_proceso_tabla').getList(1, 1, {
        filter: `nombre_proceso = "${procesoNombre}"`,
        expand: 'proceso'
      });
      
      return result.items.length > 0 ? result.items[0] : null;
    } catch (error) {
      console.error('Error fetching process info:', error);
      throw new Error('Error al obtener información del proceso');
    }
  },

  /**
   * Verifica si un proceso requiere manejo de colores
   * @param {string} procesoNombre - Nombre del proceso
   * @returns {boolean} True si requiere manejo de colores
   */
  requiresColorHandling(procesoNombre) {
    if (!procesoNombre) {
      return false;
    }

    // Verificar si el proceso es "impresión" (comparación directa)
    const proceso = procesoNombre.toLowerCase().trim();
    return proceso === 'impresión' || proceso === 'impresion';
  }
};
